export default "__VITE_ASSET__DhOREwUW__"